<template>
  <div>
  <div v-if="crmType === 'payroll'">
    <iframe src="https://dashboards.uk.cloudcall.com/271/a8b9c7611cc6870ea97df7fcffd324ebaf4d53664991c51e0535a5348c84715a/Europe/London" width="100%" frameborder="0"
            height="410px"></iframe>
    <iframe src="https://dashboards.uk.cloudcall.com/272/de257a4e6fac6d3f3964a6fa9f04afd3b161d2f6dd7f52a8e369fcd11ce69a49/Europe/London" width="100%" frameborder="0"
            height="720px"></iframe>
  </div>
  <div v-if="crmType === 'recruitment'">
    <iframe src="https://call-activity-dashboard.cloudcall.com/236/951d1a01ee661aa560c12b42fa3875fbe9b5d8bf42b9cdd96d48f2650b632e88/Europe/London" width="100%" frameborder="0"
            height="410px"></iframe>
    <iframe src="https://call-activity-dashboard.cloudcall.com/237/f6bed2b9f736815f7c2f446613309425e56157ec80fe503c8929a7893cc185b2/Europe/London" width="100%" frameborder="0"
            height="720px"></iframe>
  </div>
  </div>
</template>
<script>
export default {
  name: 'crm_activity_cloudcall_stats',
}
</script>
